export const ONE_GB_IN_BYTES = 1073741824;
export const DEFAULT_TRIAL_PERIOD = 7;
